import { render, staticRenderFns } from "./paisongdian.vue?vue&type=template&id=291eb9ac&"
import script from "./paisongdian.vue?vue&type=script&lang=js&"
export * from "./paisongdian.vue?vue&type=script&lang=js&"
import style0 from "./paisongdian.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports